import type { PortfolioEventTypeEnum } from "web_myplann/Infrastructure/Api/Api";

export const PortfolioKeys = {
	all: ["portfolio"] as const,
	portfolioList: (
		filterDatagroups?: string[],
		filterOnlyreportingenabled?: boolean,
	) =>
		[
			...PortfolioKeys.all,
			"portfolio-list",
			{ filterDatagroups, filterOnlyreportingenabled },
		] as const,
	propertyList: (
		filterDatagroups?: string[],
		filterOnlyreportingenabled?: boolean,
	) =>
		[
			...PortfolioKeys.all,
			"property-list",
			{ filterDatagroups, filterOnlyreportingenabled },
		] as const,
	portfolioDetail: (id: number | null) =>
		[...PortfolioKeys.all, "portfolio-detail", id] as const,
	propertyDetail: (id: number | null) =>
		[...PortfolioKeys.all, "property-detail", id] as const,
	instrumentDetail: (portfolioId: number | null, instrumentId: number | null) =>
		[
			...PortfolioKeys.all,
			"instrument-detail",
			portfolioId,
			instrumentId,
		] as const,
	reporting: (id: number | null) =>
		[...PortfolioKeys.all, "reporting", id] as const,
	reportingSummaries: () =>
		[...PortfolioKeys.all, "reporting-summary"] as const,
	reportingSummary: (
		filterPortfolioids?: number[],
		filterDatagroups?: string[],
	) =>
		[
			...PortfolioKeys.reportingSummaries(),
			{ filterPortfolioids, filterDatagroups },
		] as const,
	portfolioRelatedOptions: (id: number) =>
		[...PortfolioKeys.all, "portfolio-related-options", id] as const,
	propertyRelatedOptions: (id: number) =>
		[...PortfolioKeys.all, "property-related-options", id] as const,
	documents: (id: number) => [...PortfolioKeys.all, "documents", id] as const,
	propertyDocuments: (id: number | null) =>
		[...PortfolioKeys.all, "property-documents", id] as const,
	productCategories: (portfolioType: string) =>
		[...PortfolioKeys.all, "product-categories", portfolioType] as const,
	producers: (oblast: string, categoryId?: number) =>
		[...PortfolioKeys.all, "producers", oblast, categoryId ?? null] as const,
	products: (oblast: string, producerId: number) =>
		[...PortfolioKeys.all, "products", oblast, producerId] as const,
	cryptocurrencies: () => [...PortfolioKeys.all, "cryptocurrencies"] as const,
	alertBoxesAll: (id: number) =>
		[...PortfolioKeys.all, "alert-boxes", id] as const,
	// Keeps the `alertBoxesAll(id)` prefix so a dismiss still invalidates every
	// variant, including the Notification Center deep-link filters.
	alertBoxes: (
		id: number,
		bypassDismissal = false,
		eventType?: PortfolioEventTypeEnum,
		eventDate?: string,
	) =>
		[
			...PortfolioKeys.alertBoxesAll(id),
			bypassDismissal,
			{ eventType, eventDate },
		] as const,
};
